export const rootPaths = {
  index: '/',
  login: '/login',
  clients: '/clients',
  detailedClient: '/clients/:id',
}
